import { render, staticRenderFns } from "./profile-patients-ehr.vue?vue&type=template&id=1575cbba&"
import script from "./profile-patients-ehr.vue?vue&type=script&lang=js&"
export * from "./profile-patients-ehr.vue?vue&type=script&lang=js&"
import style0 from "./profile-patients-ehr.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports